<template>
  <div
    class="fb-step fb-form md-card"
    @mousedown="startDrag"
    @touchstart="startDrag"
    @mousemove="onDrag"
    @touchmove="onDrag"
    @mouseup="stopDrag"
    @touchend="stopDrag"
    @mouseleave="stopDrag"
  >
    <!-- <div class="fb-step-header"></div> -->

    <md-steppers md-alternative :md-active-step.sync="active" md-linear>
      <component
        :inStepNavigation="true"
        :key="el.uuid"
        v-for="(el, index) in slides"
        :uuid="el.uuid"
        :nid="nid"
        :sid="sid"
        :main_sid="main_sid"
        :is="el.type"
        :element="el"
        :mode="1"
        :steps="slides.length"
        :stepIndex="index"
        :active="active"
        :validate-last-step="validate"
        :validate="validate"
        :is-draft="isDraft"
        :status="status"
        :showSubmit="showSubmit"
        :validationFails="validation"
        :countFormCards="countFormCards"
        :gatekeeping="gatekeeping"
        @next-step="nextStep"
        @submit="$emit('submit')"
        @validate-form="$emit('validate-form')"
        @disable-form-validation="$emit('disable-form-validation')"
        @prev-step="prevStep"
        @set-value="$emit('set-value', $event)"
        @validation="updateValidation(index, $event)"
        @step-done="stepDone(index, $event)"
        @quiz-init="quizInit(index, $event)"
        ref="fbStep"
      ></component>
    </md-steppers>
    <div class="fb-actions">
      <span class="position-relative" :key="el.uuid" v-for="(el, index) in slides">
        <md-button
          :aria-label="buttonAreaLabel(index)"
          class="md-icon-button"
          @click="goToStep(index)"
          :class="{
            active: activeIndex == index,
            pass: index < activeIndex,
            error: (gatekeeping && validate === true && !validation[index] && index <= activeIndex) || (!gatekeeping && validate === true && !validation[index]),
          }"
        ></md-button>
        <div class="fb-tooltip" v-show="tooltipGoToStap[index]">Complete the current step to continue.</div>
      </span>
    </div>
    <spinner class="draft-spinner" v-if="showLoader"></spinner>
  </div>
</template>

<script>
import FbElementMixin from "./FbElementMixin";
import FbStep from "./FbStep.vue";
import Spinner from "./../Spinner.vue";

export default {
  name: "FbStepper",
  props: ["element", "validate", "countFormCards", "status", "showSubmit", "gatekeeping"],
  mixins: [FbElementMixin],
  components: {
    FbStep,
    Spinner
  },
  computed: {
    stepTitle() {
      return this.slides[this.activeIndex].data.label;
    },
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter((el) => {
          return el !== true;
        });
        return errors.length == 0;
      },
    },
  },
  created() {
    if (this.slides[0] && this.slides[0].uuid) {
      this.active = this.slides[0].uuid;
      this.activeIndex = 0;
    }
    if (this.countFormCards == 1 && this.submit_button_on_last_step == true && this.showSubmit) {
      this.slides[this.slides.length - 1].list.push({
        data: {},
        type: "FbSubmitError",
        list: [],
        uuid: this.$uuid.v1(),
      });
    }
    if (this.countFormCards == 1 && this.showSubmit && this.submit_button_on_last_step == false) {
      this.slides.push({
        data: {},
        list: [
          {
            data: {},
            type: "FbSubmit",
            list: [],
            uuid: this.$uuid.v1(),
          },
        ],
        type: "FbStep",
        uuid: this.$uuid.v1(),
      });
    }

    this.$emit("validation", this.valid);
  },
  mounted() {
    // Set steps buttons width.
    let setActionsButton = () => {
      let btnNum = this.slides.length;
      let actions = this.$el.querySelector(".fb-actions");
      let actionsWidth = window.jQuery(actions).width();
      let btn = actions.querySelector("button.active");
      let btnWidth = Math.floor(window.jQuery(btn).outerWidth(true));
      let btnCount = actions.querySelectorAll("button").length;
      if (btnNum && btnWidth) {
        // let linesNum = btnNum * btnWidth / actionsWidth;
        // let btnPerLine = Math.floor(actionsWidth / btnWidth);
        let newWidth = Math.floor(actionsWidth / btnCount) - 8;

        actions.style.display = "block";
        actions.querySelectorAll("button").forEach((btnItem) => {
          btnItem.style.width = newWidth + "px";
        });
      }
    };
    window.addEventListener("resize", () => {
      setActionsButton();
    });
    let checkScroll = () => {
      let el = document.querySelector(".md-steppers-wrapper");
      if (!el) {
        return;
      }
      if (el.scrollLeft != 0) {
        el.scroll(0, 0);
      }
      setTimeout(() => {
        checkScroll();
      }, 300);
    };
    checkScroll();
    setActionsButton();

    this.slides.forEach((el, index) => {
      this.tooltipGoToStap[index] = false;
      if (index > 0) {
        let slide = document.querySelector('[uuid="' + el.uuid + '"]');
        if (slide) {
          slide.style.visibility = "hidden";
        }
        if (el.uuid == this.active) {
          if (slide) {
            slide.style.visibility = null;
          }
        }
      }
    });

    if(this.gatekeeping) {
      // Run validation on init and disable it to not show errors before user click next.
      this.$emit("validation", this.valid);
      this.$emit("validate-form");
      this.$emit("disable-form-validation");
      // this.$emit("validation", this.valid);
    }
    // Start autosave session.
    this.$emit("autosave-start");
  },
  data() {
    return {
      tooltipGoToStap: [],
      showLoader: false,
      dragging: false,
      c: { x: 0, y: 0 },
      start: { x: 0, y: 0 },
      active: "",
      activeIndex: 0,
      validation: [],
      quizes: [],
      slides: this.element.list.slice(0),
      submit_button_on_last_step: drupalSettings.form_builder ? !!+drupalSettings.form_builder[this.nid].field_submit_button_on_last_step : 0
    };
  },
  methods: {
    buttonAreaLabel(index) {
      return 'Slide' + index;
    },
    startDrag: function (e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      this.dragging = true;
      this.start.x = e.pageX;
      this.start.y = e.pageY;
    },
    onDrag: function (e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      if (this.dragging) {
        this.c.x = e.pageX - this.start.x;
        this.c.y = e.pageY - this.start.y;
        if (Math.abs(this.c.x) < 20) {
          return false;
        } else if (Math.abs(this.c.y) > 20) {
          this.stopDrag();
          return false;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        let el = this.$el.querySelector(".md-steppers-container");
        el.style.transition = "0s";
        let elWidth = el.offsetWidth;
        let pr = (this.c.x * 100) / elWidth;
        if (Math.abs(pr) > 10) {
          el.style.transform =
            "translate3d(" + -this.activeIndex * 100 + "%, 0 , 0)";
          el.style.transition = null;
          if (pr < 0) {
            this.nextStep(this.activeIndex);
          } else {
            this.prevStep(this.activeIndex);
          }
          this.stopDrag();
        }
        let move = -this.activeIndex * 100 + pr;
        el.style.transform = "translate3d(" + move + "%, 0 , 0)";
        return false;
      }
    },
    stopDrag: function (e) {
      let el = this.$el.querySelector(".md-steppers-container");
      el.style.transform =
        "translate3d(" + -this.activeIndex * 100 + "%, 0 , 0)";
      el.style.transition = null;
      if (this.dragging) {
        this.dragging = false;
      }
    },
    setStepHeight() {
      const stepperElement = this.$el.querySelector(`.md-stepper:nth-child(${this.activeIndex + 1})`);
      const stepperWrapper = stepperElement.closest(".md-steppers-wrapper");
      setTimeout(() => {
        stepperWrapper.style.height = `${stepperElement.offsetHeight}px`;
      }, 300);
    },
    goToStep(stepIndex) {
      if (this.gatekeeping && stepIndex > this.activeIndex && !this.validation[this.activeIndex]) {
        let tooltipGoToStap = this.tooltipGoToStap.splice();
        tooltipGoToStap[stepIndex] = true;
        this.tooltipGoToStap = tooltipGoToStap;
        this.setStepHeight();
        setTimeout(()=>{
          let tooltipGoToStap = this.tooltipGoToStap.splice();
          tooltipGoToStap[stepIndex] = false;
          this.tooltipGoToStap = tooltipGoToStap;
        }, 3000);
        this.nextStep(this.activeIndex);
        return;
      }
      else if (this.gatekeeping && stepIndex == this.activeIndex + 1 && this.validation[this.activeIndex]) {
        this.nextStep(this.activeIndex);
        return;
      }
      else if (this.gatekeeping && stepIndex == this.slides.length - 1 && !this.valid) {
        return;
      }

      this.showLoader = true;
      this.$emit("submit-draft",  (result) => {
        if (result) {
          this.activeIndex = stepIndex;
          this.active = this.slides[this.activeIndex].uuid;
        }
        this.showLoader = false;
      });
    },
    nextStep(currStep, ignoreDraft) {
      if (this.gatekeeping && !this.validation[currStep]) {
        this.$emit("validation", this.valid);
        this.$emit("validate-form");
        this.$emit("validation", this.valid);
        return;
      }
      if (this.gatekeeping) {
        this.$emit("validation", this.valid);
        this.$emit("disable-form-validation");
        this.$emit("validation", this.valid);
      }
      if (ignoreDraft === true) {
        this.activeIndex = currStep + 1;
        this.active = this.slides[this.activeIndex].uuid;
        return;
      }
      this.showLoader = true;
      this.$emit("submit-draft",  (result) => {
        if (result) {
          if (currStep < this.slides.length - 1) {
            this.activeIndex = currStep + 1;
            this.active = this.slides[this.activeIndex].uuid;
            //this.$emit("submit-draft");
          }
        }
        this.showLoader = false;
      });
    },
    prevStep(currStep) {
      this.showLoader = true;
      this.$emit("submit-draft",  (result) => {
        if (result) {
          if (currStep > 0) {
            this.activeIndex = currStep - 1;
            this.active = this.slides[this.activeIndex].uuid;
          }
        }
        this.showLoader = false;
      });
    },
    stepDone(currStep) {
      if (
        this.status == this.$status.ACTIVITY_COMPLETED ||
        this.status == this.$status.ACTIVITY_REVIEW_NEEDED
      ) {
        return;
      }
      this.nextStep(currStep, true);
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    },
    async quizInit(index, event) {
      this.quizes.push(event);
      this.showLoader = true;
      if (this.quizes.length == this.$el.querySelectorAll('.quiz-iframe-wrapper').length) {
        for (const step of this.$refs.fbStep) {
          if (step.$refs.fbChild[0].$options._componentTag == 'FbQuiz') {
            await step.$refs.fbChild[0].initIframe();
          }
        }
        this.showLoader = false;

      }
    }
  },
  watch: {
    element() {
      this.active = this.slides.length > 0 ? this.slides[0].uuid : "";
      this.activeIndex = 0;
    },
    active(newVal) {
      let self = this;
      this.slides.map((el, index) => {
        let slide = document.querySelector('[uuid="' + el.uuid + '"]');
        if (slide) {
          slide.style.visibility = "hidden";
        }
        if (el.uuid == newVal) {
          self.activeIndex = index;
          if (slide) {
            slide.style.visibility = null;
          }
        }
      });
      if (
        this.activeIndex == this.slides.length - 1 &&
        this.countFormCards == 1
      ) {
        this.$emit("validation", this.valid);
        this.$emit("validate-form");
        this.$emit("validation", this.valid);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.draft-spinner {
  background-color: rgba(0, 0, 0, 0);
}
</style>

<style lang="scss">
.fb-step.fb-form {
  .fb-prev {
    float: left;
    color: $blue-active;
    margin-left: -18px;
  }
  .fb-next {
    float: right;
    margin-right: 0;
  }
  .fb-actions {
    padding: 26px 16px;
    display: flex;
  }
  position: relative;
  .fb-actions {
    .md-icon-button {
      .md-ripple,
      .md-icon-button:before {
        border-radius: 0px;
      }
      width: auto;
      min-width: 32px;
      flex: 1;
      height: 8px;
      border-radius: 4px;
      margin: 0 4px 0 4px;
      background-color: #e3e2e8;
      &.active,
      &.pass {
        background-color: $blue-active;
      }
      &.error.error {
        overflow: visible;
        background-color: #e63950;
        &:after {
          position: absolute;
          width: 10px;
          height: 10px;
          display: block;
          content: "";
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 56 (81588) - https://sketch.com --%3E%3Ctitle%3E-g-24px (11) copy%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='-g-24px-(11)-copy' transform='translate(-1.000000, -1.000000)'%3E%3Cpolygon id='Path' points='0 0 16 0 16 16 0 16'%3E%3C/polygon%3E%3Cpath d='M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M8.66666667,11.3333333 L7.33333333,11.3333333 L7.33333333,10 L8.66666667,10 L8.66666667,11.3333333 Z M8.66666667,8.66666667 L7.33333333,8.66666667 L7.33333333,4.66666667 L8.66666667,4.66666667 L8.66666667,8.66666667 Z' id='Shape' fill='%23E63950' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
          background-size: 10px;
          top: -15px;
          left: 50%;
          margin-left: -5px;
        }
      }
    }
  }
  .md-stepper,
  .md-stepper-content {
    /*min-height: 400px;*/
    /*@media all and (max-width: 500px) {*/
    /*min-height: 300px;*/
    /*min-height: calc(100vh - 400px);*/
    /*}*/
    min-height: 90px;
    @media all and (max-width: 500px) {
      min-height: 150px;
    }
  }
}

.fb-step-header {
  min-height: 156px;
  @media all and (max-width: $breakpoint-medium) {
    min-height: 109px;
  }
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: $blue-active;
}
.module-activity .fb-step-header,
.field_ready_form .fb-step-header {
  display: none;
}

.fb-step h5.label {
  display: none;
}

.fb-step.fb-form h5.label {
  display: block;
  margin-bottom: 12px;
}

.field_go_form {
  .fb-step-header {
    background-image: url("../../assets/go_header.svg");
    background-position: top center;
    background-position: top 5px left -37px;
    background-size: 500px auto;
    @media all and (min-width: 1100px) {
      background-position: center top 0px;
      background-size: auto 700px;
    }
    // @media all and (max-width: 1100px) {
    //   background-position: left 2px top -90px;
    //   background-size: auto 453px;
    // }
    @media all and (max-width: $breakpoint-medium) {
      background-position: center top 0px;
      background-size: auto 512px;
    }
    @media all and (max-width: 500px) {
      background-position: left -27px top 0;
      background-size: auto 500px;
    }
    @media all and (max-width: 350px) {
      background-position: left -30px top 0px;
      background-size: auto 475px;
    }
  }
}
.field_set_form {
  .fb-step-header {
    background-image: url("../../assets/set_graphic.svg");
    background-repeat: no-repeat;
    background-size: auto 453px;
    background-position: center top -90px;
    @media all and (min-width: 1100px) {
      background-position: center 2px top;
      background-size: auto 453px;
    }
    @media all and (max-width: 1100px) {
      background-position: left 2px top -90px;
      background-size: auto 453px;
    }
    @media all and (max-width: $breakpoint-medium) {
      background-position: center top -69px;
      background-size: auto 316px;
    }
    @media all and (max-width: 500px) {
      background-position: left 2px top -69px;
      background-size: auto 316px;
    }
  }
}
.md-steppers.md-alternative {
  background-color: transparent;
  margin-top: 60px;
  @media all and (max-width: $breakpoint-medium) {
    margin-top: 0px !important;
  }
  display: flex;
  flex-flow: column;
  border-radius: 20px;
  .fb-navigation {
    padding-top: 24px;
  }
  .md-steppers-navigation {
    display: none;
    box-shadow: none;
  }
  .fb-actions {
    padding: 16px 16px 24px;
  }
  .md-stepper,
  .md-stepper-content {
    display: flex;
    flex-direction: column;
    padding-bottom: 0px;

    .step-content {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}
.fb-tooltip{
  position: absolute;
  top: -10px;
  left: 50%;
  max-width: 250px;
  width: 100%;
  transform: translate3d(-50%, -100%, 0);
  background-color: rgba(0,0,0,0.7);
  color: white;
  padding: 6px;
  border-radius: 4px;
  max-width: 200px;
  width: 200px;
  text-align: center;
}
.position-relative {
  position: relative;
}
.fb-next.disabled {
  background-color: rgba(0, 0, 0, 0.12) !important;
  color: rgba(0, 0, 0, 0.26) !important;
}
.fb-tooltip-right {
  position: absolute;
  top: -10px;
  right: 0;
  left: auto;
  max-width: 250px;
  width: 250px;
  transform: translate3d(0, -100%, 0);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 6px;
  border-radius: 4px;
  text-align: center;
}
</style>
